import React from "react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";

import { titles } from "../../../constants/titles";
import {
  nextYearClassesPath,
  nextYearStudentsPath,
} from "../../../managerStore";
import { ModalContext } from "../../../libs/ModalProvider";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import Confirm from "../../../molecules/Confirm";

import styles from "./ExchangeSchoolYearBoard.module.scss";

interface IExchangeSchoolYearBoardDispatchProps {
  exchangeYearNow: () => void;
}

interface IExchangeSchoolYearBoardStateProps {
  title: string;
  calling: boolean;
  change_current_year_status: "open" | "inprogress" | "done";
  changed_current_year_plan_date: Date | null;
}

export interface IExchangeSchoolYearBoardProps
  extends IExchangeSchoolYearBoardDispatchProps,
    IExchangeSchoolYearBoardStateProps {}

export const ExchangeSchoolYearBoard = (
  props: IExchangeSchoolYearBoardProps,
) => {
  const ctx = React.useContext(ModalContext);
  const history = useHistory();
  const { currentYear, nextYear } = useCurrentYear();
  const [isChangeNowClicked, setIsChangeNowClicked] = React.useState(false);

  return (
    <div className={styles.wrapper}>
      <div className={styles.pageTitleWrapper}>
        <h3>{props.title}</h3>
        <div className={styles.description}>
          <p>
            {nextYear}
            年度の利用を開始する前に、年度切替を実施する必要があります。
          </p>
        </div>
      </div>
      <div className={styles.section}>
        <div className={styles.sectionTitleWrapper}>
          <div className={styles.title}>● {nextYear}年度クラス登録</div>
          <div className={styles.tag}>任意</div>
        </div>
        <div className={styles.description}>
          <p>
            {nextYear}年度のクラスをあらかじめ登録することができます。
            <br />
            <span className={styles.note}>
              ※年度切替前の事前登録を推奨しています。
              <br />
              ※年度切替の後に追加登録することも可能です。
            </span>
          </p>
        </div>
        <button
          className="btn btn-outline-primary"
          onClick={() => {
            history.push(nextYearClassesPath);
          }}
        >
          {nextYear}年度{titles.nextYearClasses}画面へ
        </button>
      </div>
      <div className={styles.section}>
        <div className={styles.sectionTitleWrapper}>
          <div className={styles.title}>● {nextYear}年度生徒のクラス登録</div>
          <div className={styles.tag}>任意</div>
        </div>
        <div className={styles.description}>
          <p>
            現年度にご利用中の生徒について、来年度のクラスをあらかじめ登録することができます。
            <br />
            <span className={styles.note}>
              ※年度切替前の事前登録を推奨しています。
              <br />
              ※年度切替前に生徒を追加し、来年度のクラスを事前登録することも可能です。
              <br />
              ※年度切替の後に追加登録することも可能です。
            </span>
          </p>
        </div>
        <button
          className="btn btn-outline-primary"
          onClick={() => {
            history.push(nextYearStudentsPath);
          }}
        >
          {nextYear}年度{titles.nextYearStudents}画面へ
        </button>
      </div>
      <div className={styles.section}>
        <div className={styles.sectionTitleWrapper}>
          <div className={styles.title}>
            ● {`年度更新 (${currentYear}年度→${nextYear}年度)`}
          </div>
          <div className={clsx(styles.tag, styles.danger)}>必須</div>
        </div>
        <div className={styles.description}>
          <p>
            現在の年度を切り替え、生徒の学年を更新します。
            <br />
            また、{nextYear}
            年度生徒の所属クラスを設定済みの場合、所属クラスも更新します。
            <br />
            <span className={styles.note}>
              ※未設定の場合は、生徒の所属クラスは空欄になります。
            </span>
          </p>
        </div>
        <button
          className={clsx("btn btn-outline", styles.utilBtn)}
          onClick={() => {
            ctx.actions.showModal(
              <Confirm
                content={"年度を変えてもよろしいですか?"}
                closeModal={() => {
                  ctx.actions.closeModal();
                }}
                callback={() => {
                  props.exchangeYearNow();
                  setIsChangeNowClicked(true);
                }}
              />,
            );
          }}
          disabled={
            !(props.change_current_year_status === "open") || isChangeNowClicked
          }
        >
          年度切替の実行
        </button>
        <div className={styles.description}>
          <p>
            (注意)
            <br />・{nextYear}年度の納品完了後に教材が利用可能になります。
            <br />
            ・年度更新後の新しいクラス編成で授業を実施する際、新クラスに対して「教材の開放」を行う必要があります。
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExchangeSchoolYearBoard;
